"use strict";

exports.__esModule = true;
exports.getPlantStateColor = getPlantStateColor;
var PLANT_STATE_COLOR_KEYS = {
  producing: "ProducingStateColor",
  setup: "SetupStateColor",
  standby: "StandbyStateColor",
  "downtime.unplanned": "UnplannedDowntimeStateColor",
  "downtime.planned": "PlannedDowntimeStateColor",
  "data-unavailable": "DataUnavailableStateColor",
  shutdown: "ShutdownStateColor"
};

/**
 * Get the color for a particular plant state.
 */
function getPlantStateColor(theme, stateId) {
  return theme && theme[PLANT_STATE_COLOR_KEYS[stateId]] || "transparent";
}